import { EConditionType } from 'shared/json_query';

import { ensureSingleTagExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IManufactureConditionsTagType = 'advanced-manufactureCondition';

export interface IManufactureConditionsTag {
  type: 'advanced-manufactureCondition';
  value: EConditionType;
}

const isManufactureConditionsTag = (tag: TTag): tag is IManufactureConditionsTag =>
  tag.type === IManufactureConditionsTagType;

export const manufactureConditionTypesTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const values = jsonQuery.condition_type__industry && jsonQuery.condition_type__industry.value;

    let nextTags = tags.filter(
      tag => tag.type !== IManufactureConditionsTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce(
        (result, value: EConditionType) =>
          ensureSingleTagExists(
            result,
            (tag: TTag): tag is IManufactureConditionsTag => isManufactureConditionsTag(tag) && tag.value === value,
            () => ({ type: IManufactureConditionsTagType, value }),
          ),
        nextTags,
      );
    }

    return nextTags;
  },
};
